import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  TextField,
  Grid,
} from "@mui/material";
import { border, styled } from "@mui/system";
import Navbar from "components/Navbar/index";
import TestimonialsSection from "components/TestimonialsSection/index";
import FeaturesSection from "components/FeaturesSection/index";
import FeatureBenefitsSection from "components/FeatureBenefitsSection/index";
import TestimonialsCarouselSection from "components/TestimonialsCarouselSection/index";
import PricingSection from "components/PricingSection/index";
import ConsultationSection from "components/ConsultationSection/index";
import FooterSection from "components/FooterSection/index";

// Styled Components for Email Input
const CustomBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#363636",
  padding: "5px",
  borderRadius: "6px",
  width: "100%",
});

const CustomInput = styled(TextField)({
  flex: 1,
  "& .MuiInputBase-root": {
    color: "#fff",
    backgroundColor: "#363636 !important",
    borderRadius: "6px 0px 0px 6px",
    width: "100%",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#363636 !important",
    borderRadius: "6px 0px 0px 6px !important",
    border: "none !important",
    width: "100%",
    "& fieldset": {
      border: "none !important",
    },
    "&:hover fieldset": {
      border: "none !important",
    },
    "&.Mui-focused fieldset": {
      border: "none !important",
    },
  },
  "& .MuiInputBase-input": {
    padding: "10px 14px",
    color: "#fff !important",
    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.6) !important",
      opacity: 1,
    },
  },
  "& .MuiInputLabel-root": {
    color: "#aaa",
  },
});

const CustomButton = styled(Button)({
  backgroundColor: "#4ef4ff",
  color: "#000",
  fontWeight: "bold",
  borderRadius: "6px",
  textTransform: "none",
  padding: "10px 20px",
  minWidth: "140px",
  flexShrink: 0,
  "&:hover": {
    backgroundColor: "#3bd6e0",
  },
});

const LandingPage = () => {
  const [email, setEmail] = useState("");

  const handleGetStarted = () => {
    // Handle email submission logic here
    console.log("Email submitted:", email);
  };

  const ellipseImages = [
    require("assets/images/Ellipse1.png"),
    require("assets/images/Ellipse2.png"),
    require("assets/images/Ellipse3.png"),
    require("assets/images/Ellipse4.png"),
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
        color: "white",
        position: "relative",
        fontFamily: "Outfit",
      }}
    >
      {/* Navbar Component */}
      <Navbar />

      {/* Main Content */}
      <Container maxWidth="xl" sx={{ pt: 12 }}>
        <Grid container sx={{ minHeight: "80vh", alignItems: "center" }}>
          {/* Left Section - Hero Content */}
          <Grid item xs={12} lg={4}>
            <Box sx={{ pr: { lg: 4 } }}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: "600px",
                  fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                  lineHeight: 1.2,
                  mb: 1,
                  background: "linear-gradient(45deg, #ffffff, #e0e0e0)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Nourish Body Live Healthy Today
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: "rgba(255, 255, 255, 0.8)",
                  mb: 3,
                  fontWeight: 400,
                  lineHeight: 1.3,
                  fontSize: { xs: "1rem", md: "24px" },
                }}
              >
                Personalized meal plans, workouts, and progress tracking all in
                one app. Your coach, your pace, your results.
              </Typography>

              {/* Email Input Section */}
              {/* <Box sx={{ mb: 3}}>
                <CustomBox>
                  <CustomInput
                    placeholder="Email ID"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                    size="medium"
                  />
                  <CustomButton
                    onClick={handleGetStarted}
                    variant="contained"
                  >
                    Get Started
                  </CustomButton>
                </CustomBox>
              </Box> */}

              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  fontSize: "24px",
                  fontWeight: 400,
                  lineHeight: "1.3",
                }}
              >
                Empowering 500+ Dietitians to Grow Smarter.
              </Typography>
            </Box>
          </Grid>

          {/* Middle Section - Image 1 */}
          <Grid item xs={12} lg={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: { xs: "300px", sm: "350px", md: "400px", lg: "500px" },
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src={require("assets/images/home1.png")}
                alt="Hero Image"
                sx={{
                  width: "100%",
                  height: "100%",
                  maxWidth: {
                    xs: "250px",
                    sm: "280px",
                    md: "300px",
                    lg: "500px",
                  },
                  objectFit: "contain",
                }}
              />
            </Box>
          </Grid>

          {/* Right Section - Image 2 & Content */}
          <Grid item xs={12} lg={4}>
            <Box sx={{ pl: { lg: 4 } }}>
              {/* Image 2 */}
              <Box
                sx={{
                  width: "100%",
                  height: {
                    xs: "300px",
                    sm: "350px",
                    md: "400px",
                    lg: "300px",
                  },
                  borderRadius: "30px",
                  mb: 3,
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={require("assets/images/home2.png")}
                  alt="Hero Image 2"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </Box>

              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.8)",
                  mb: 4,
                  lineHeight: 1.6,
                  fontSize: "0.95rem",
                }}
              >
                We help dietitians and nutrition professionals streamline their
                workflow with automated scheduling, billing, secure client
                messaging, and progress tracking all in one easy to use
                platform.
              </Typography>

              {/* Nutrition Experts Section */}
              <Box
                sx={{
                  background: "linear-gradient(45deg, #17c1e8, #00bcd4)",
                  borderRadius: "80px",
                  p: 1.5, // reduced padding so avatars fit
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  overflow: "hidden", // prevents images from spilling outside
                }}
              >
                <Box sx={{ display: "flex", gap: 0 }}>
                  {ellipseImages.map((image, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        ml: index > 0 ? -1.5 : 0, // smaller overlap
                        zIndex: index,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={image}
                        alt={`Expert ${index + 1}`}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  ))}
                </Box>

                <Typography
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    whiteSpace: "nowrap",
                    lineHeight: 1.2,
                  }}
                >
                  100 +<br />
                  Nutrition Experts
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* About Us Section */}
        <Box sx={{ py: 8, textAlign: "center" }}>
          <Typography
            variant="h6"
            sx={{
              color: "#17c1e8",
              fontSize: "20px",
              fontWeight: 600,
              mb: 1,
              fontFamily: "Outfit",
            }}
          >
            About Us
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: "#FFFFFF",
              fontSize: { xs: "32px", md: "36px" },
              fontWeight: 600,
              mb: 1,
              lineHeight: 1.2,
              fontFamily: "Outfit",
            }}
          >
            Empowering Nutrition Professionals to Do More
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "rgba(255, 255, 255, 0.8)",
              margin: "0 auto",
              lineHeight: 1.6,
              fontFamily: "Outfit",
              fontWeight: 400,
              fontSize: { xs: "1rem", md: "1.1rem" },
            }}
          >
            Fitify simplifies scheduling, billing, and client engagement so
            dietitians can focus on improving lives not managing admin tasks.
          </Typography>
        </Box>

        {/* Passion Section */}
        <Box sx={{ py: 4 }}>
          <Grid container spacing={6} alignItems="center">
            {/* Left Side - Images */}
            <Grid item xs={12} md={6} lg={6}>
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  flexDirection: { xs: "column", md: "row", lg: "row" },
                  gap: { xs: 3, md: 4, lg: 4 },
                }}
              >
                {/* Food Image */}
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: "250px", md: "280px", lg: "300px" },
                    height: { xs: "250px", md: "280px", lg: "450px" },
                  }}
                >
                  {/* Decorative dashed line */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-30px",
                      right: "-20px",
                      width: "100px",
                      height: "2px",
                      transform: "rotate(15deg)",
                      display: { xs: "none", lg: "block" },
                    }}
                  />

                  <Box
                    component="img"
                    src={require("assets/images/about1.png")}
                    alt="About 1"
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "20px",
                      objectFit: "cover",
                    }}
                  />
                </Box>

                {/* Woman Image */}
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: "280px", md: "320px", lg: "350px" },
                    height: { xs: "280px", md: "320px", lg: "700px" },
                  }}
                >
                  {/* Decorative dashed line */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-40px",
                      left: "-30px",
                      width: "120px",
                      height: "2px",
                      transform: "rotate(-15deg)",
                      display: { xs: "none", lg: "block" },
                    }}
                  />

                  <Box
                    component="img"
                    src={require("assets/images/about2.png")}
                    alt="About 2"
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50px 50px 0 0",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Right Side - Content */}
            <Grid item xs={12} lg={6}>
              <Box sx={{ pl: { lg: 4 } }}>
                <Typography
                  variant="h3"
                  sx={{
                    color: "#17c1e8",
                    fontSize: { xs: "1.8rem", md: "2.2rem", lg: "2.5rem" },
                    fontWeight: "bold",
                    mb: 5,
                    lineHeight: 1.3,
                  }}
                >
                  Passion for Empowering Nutrition Professionals with Smart
                  Automation
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: { xs: "1rem", md: "1.1rem" },
                    lineHeight: 1.7,
                    mb: 5,
                  }}
                >
                  At Fitify, we're dedicated to helping dietitians and
                  nutritionists build thriving practices. From automated
                  scheduling and billing to secure client communication, our
                  tools let you focus on what matters most delivering better
                  health outcomes.
                </Typography>

                <Box sx={{ mb: 4 }}>
                  {[
                    "Streamline your daily tasks",
                    "Improve client engagement",
                    "Grow your practice effortlessly",
                  ].map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(45deg, #FFFFFF, #FFFFFF)",
                          mr: 2,
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Button
                  sx={{
                    background: "linear-gradient(45deg, #17c1e8, #00bcd4)",
                    color: "#000000",
                    px: 4,
                    py: 1.5,
                    borderRadius: "16px",
                    fontSize: "1rem",
                    fontWeight: 400,
                    textTransform: "none",
                    "&:hover": {
                      background: "linear-gradient(45deg, #00bcd4, #17c1e8)",
                      transform: "translateY(-2px)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  More About Us
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Social Proof / Testimonials Section */}
        <TestimonialsSection />

        {/* Features Section */}
        <FeaturesSection />

        {/* Feature Benefits Section */}
        {/* <FeatureBenefitsSection /> */}

        {/* Testimonials Carousel Section */}
        <Box id="testimonials">
          <TestimonialsCarouselSection />
        </Box>

        {/* Pricing Section */}
        <Box id="pricing">
          <PricingSection />
        </Box>

        {/* Consultation Section */}
        <Box id="contact">
          <ConsultationSection />
        </Box>
      </Container>

      {/* Footer Section */}
      <FooterSection />
    </Box>
  );
};

export default LandingPage;
